/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useMemo } from 'react';
import { useConfiguration } from '../../redux/features/configuration/useConfiguration';
import { useScreenSize } from '../../shared/theming/useScreenSize';
import TableConfigBuilder from './foTableBuilder/TableConfigBuilder';
import { TABLE_SIZE } from './foTableBuilder/FOCellTypes';

export default function useTableConfiguration(configResource, procedureId) {
  const { isExtraLargeOrBigger } = useScreenSize();

  // only contains column configuration at the moment
  const tableConfiguration = useConfiguration(configResource, procedureId);

  return useMemo(() => {
    if (tableConfiguration?.ready) {
      return {
        columns: tableConfiguration,
        table: new TableConfigBuilder()
          .setSize(TABLE_SIZE.SMALL)
          .setHasHeader(true)
          .setHasFooter(true)
          .setExtraLargeOrBigger(isExtraLargeOrBigger)
          .setEmptyTableCol(tableConfiguration?.resource?.filter(column => column.showOnNonXLDevice !== false).length)
          .setXlEmptyCol(tableConfiguration?.resource?.length)
          .build(),
      };
    }
    return {};
  }, [procedureId, isExtraLargeOrBigger, tableConfiguration?.ready]);
}
